// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1wQSx","info":"Note_info__2oWij","note":"Note_note__1rRKP","actions":"Note_actions__2HvD1"};